<template>
<span>
         <el-form-item label="运营人员：" class="query-form-item" v-if="type===1">
             <el-select v-model="query.operation_id" placeholder="请选择" size="mini" style="width: 100px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="item.full_name" :value="item.id"
                               v-for="item in managerAnalysisList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="ID:" class="query-form-item">
                <el-input style="width: 100px;" clearable v-model="query.id" placeholder="请输入ID"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="国家" prop="state">
                <el-select v-model="query.state" style="width: 150px;" size="mini" filterable>
                    <el-option
                        v-for="item in $common.us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="ASIN：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入ASIN"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="父ASIN：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.parent_asin" placeholder="请输入父ASIN"
                          size="mini"></el-input>
            </el-form-item>

             <el-form-item label="品名：" class="query-form-item">
                <el-input v-model="query.product_name" placeholder="请输入品名" size="mini"></el-input>
            </el-form-item>

            <el-form-item label="是否有专利值:" class="query-form-item">
                <el-select v-model="query.has_patent_value" placeholder="状态" size="mini" style="width: 100px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="有" :value="1"></el-option>
                    <el-option label="没有" :value="0"></el-option>
                </el-select>
            </el-form-item>

          <el-form-item label="标品类型：" class="query-form-item">
              <el-select v-model="query.standard_product_type" placeholder="标品类型" size="mini" style="width: 110px;">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="未录入" :value="-1"></el-option>
                  <el-option :label="item.name" :value="item.value"
                             v-for="item in standardProductTypeArr"></el-option>
              </el-select>
          </el-form-item>

        <el-form-item label="FBA费用核对：" class="query-form-item">
            <el-select v-model="query.check_fba_charge" placeholder="FBA费用核对" size="mini">
                <el-option :label="item.name" :value="item.value"
                           v-for="item in collateArr"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="是否主卖">
                    <el-select v-model="query.is_main_seller" placeholder="是否主卖" size="mini">
                        <el-option :label="item.name" :value="item.value" v-for="item in isMainSellerArr"></el-option>
                    </el-select>
                 </el-form-item>
                    <el-form-item label="包装核对：" class="query-form-item">
                        <el-select v-model="query.check_packing" placeholder="包装核对" size="mini">
                            <el-option :label="item.name" :value="item.value" v-for="item in collateArr"></el-option>
                        </el-select>
                    </el-form-item>

                 <el-form-item label="价格核对：" class="query-form-item">
                        <el-select v-model="query.check_price" placeholder="价格核对" size="mini">

                            <el-option :label="item.name" :value="item.value" v-for="item in isLowPrice"></el-option>
                        </el-select>
                    </el-form-item>

    <!--                    <el-form-item label="vine情况：" class="query-form-item">-->
    <!--                        <el-select v-model="query.vine_status" placeholder="vine情况" size="mini">-->
    <!--                            <el-option :label="item.name" :value="item.value" v-for="item in vineStatusArr"></el-option>-->
    <!--                        </el-select>-->
    <!--                    </el-form-item>-->

    <!--                   <el-form-item label="是否有广告组：" class="query-form-item">-->
    <!--                        <el-select v-model="query.had_ad_groups" placeholder="请选择" size="mini" style="width: 100px;">-->
    <!--                            <el-option label="全部" value=""></el-option>-->
    <!--                            <el-option label="是" :value="1"></el-option>-->
    <!--                            <el-option label="否" :value="0"></el-option>-->
    <!--                        </el-select>-->
    <!--                    </el-form-item>-->

            <el-form-item label="是否季节性：" class="query-form-item">
                <el-select v-model="query.is_seasonality" placeholder="季节性" size="mini" style="width: 100px;">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="季节：" class="query-form-item">
                <el-select v-model="query.season" placeholder="请选择" size="mini" filterable style="width: 100px;">
                    <el-option :label="item.label" :value="item.value"
                               v-for="item in $common.seasonArr"></el-option>
                </el-select>
            </el-form-item>

              <el-form-item label="价格：">
                <el-input-number style="width: 150px;" clearable v-model="query.min_price" placeholder="最小"
                                 :min="0" :step="0.01" size="mini"></el-input-number>
                -
                <el-input-number style="width: 150px;" clearable v-model="query.max_price" placeholder="最大"
                                 :min="0" :step="0.01" size="mini"></el-input-number>
            </el-form-item>

            <form-new-range-item :queryTemp="query" ref="formRangeItem"></form-new-range-item>

</span>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys'

export default {
    name: 'realTimeQueryTemplate',
    props: ['queryTemp', 'type'],
    watch: {
        'queryTemp': {
            handler(val) {
                this.query = val
            },
            immediate: true,
            deep: true
        },
    },
    created() {
        if (this.type === 1) {
            this.initFunc()
        }
    },
    data() {
        return {
            vineStatusArr: [
                {name: '全部', value: ''},
                {name: '未申请', value: '未申请'},
                {name: '申请中', value: '申请中'},
                {name: '完成', value: '完成'},
                {name: '老品', value: '老品'},
            ],
            collateArr: [
                {name: '全部', value: ''},
                {name: '已核对', value: 1},
                {name: '未核对', value: 0},
            ],
            query: {},
            standardProductTypeArr: [
                {name: '标品-大众', value: '标品-大众'},
                {name: '标品-小众', value: '标品-小众'},
                {name: '非标-大众', value: '非标-大众'},
                {name: '非标-小众', value: '非标-小众'},
            ],
            isLowPrice: [
                {name: '全部', value: ''},
                {name: '是', value: 1},
                {name: '否', value: 0},
            ],
            isMainSellerArr: [
                {name: '全部', value: ''},
                {name: '未核对', value: -1},
                {name: '是', value: 1},
                {name: '否', value: 0},
            ],
            managerAnalysisList: [],
        }
    },
    methods: {
        initFunc() {
            api.manager_index_get_operator_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.managerAnalysisList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        handleQueryData() {
            let queryItems = JSON.parse(JSON.stringify(this.query))

            const tempQuery = this.$refs.formRangeItem.handleQueryData()

            return Object.assign(queryItems, tempQuery)
        }
    }
}
</script>

<style scoped lang="scss">

</style>
